export const MIN_DIVIDER_THICKNESS = 1;
export const MAX_DIVIDER_THICKNESS = 4;
export const DEFAULT_DIVIDER_THICKNESS = 1;

export interface DividerThicknessOption {
    label: string;
    value: number;
}

export const DIVIDER_THICKNESS_OPTIONS: DividerThicknessOption[] = [
    {label: "Thin", value: 1},
    {label: "Medium", value: 2},
    {label: "Thick", value: 4},
];

// Normalize blank labels to null so they do not open an empty gap in the rule.
export const parseDividerLabel = (value: unknown): string | null => {
    if (typeof value !== "string") return null;

    const trimmedValue = value.trim();

    return trimmedValue ? trimmedValue : null;
};

export const clampDividerThickness = (value: unknown, fallback = DEFAULT_DIVIDER_THICKNESS): number => {
    const numberValue = typeof value === "number" ? value : Number(value);

    if (!Number.isFinite(numberValue)) return fallback;

    return Math.min(MAX_DIVIDER_THICKNESS, Math.max(MIN_DIVIDER_THICKNESS, Math.round(numberValue)));
};
